'use strict';

var Promise = require('bluebird');
var request = require('./blueAgent');
var metrics = require('superagent-metrics').default;
var _ = require('lodash');
var legacyIESupport = require('superagent-legacyiesupport');
/* implementation used by menu */
var logger = require('wendys-kenny-loggins').KennyLoggins.getLogger('common-web.service_clients.serviceClientBase');

/* elk stack logging implementation for script: web */
var elkSessionLogger = require('../lib/elk/local.session.logger').default;
var elkStackLog;
var initElkStackLoggingForSession = function initElkStackLoggingForSession() {
    if (!!elkStackLog && elkStackLog.hasOwnProperty('logger')) return true;
    elkStackLog = elkSessionLogger.initialize('common-web:service_clients/serviceClientBase');
    return elkStackLog.hasOwnProperty('logger');
};

var getLogger = function getLogger() {
    return !logger || logger.name === 'default' ? logger = require('wendys-kenny-loggins').KennyLoggins.getLogger('common-web.service_clients.serviceClientBase') : null;
};

metrics(request);

//base object1
function ServiceClientBase() {};

/**
 * wraps service client call promise and checks for hte generic "SUCCESS" from
 * jeremy's api
 * @param blueAgentCall
 * @returns {*}
 */
ServiceClientBase.prototype.wrapInSuccessCheck = function (blueAgentCall) {
    getLogger();

    return blueAgentCall.then(function (data) {
        var amendedResponse = {
            headers: {
                ETag: data.header['etag'] || ''
            },
            statusCode: data.status
        };
        var responseData = _.merge({}, amendedResponse, data.body);

        if (data.body.serviceStatus === 'SUCCESS') {
            if (initElkStackLoggingForSession()) elkStackLog.logger.info(elkStackLog.modelFactory.resModel('wrapInSuccessCheck', data));else logger.info({ res: data });
            return Promise.resolve(responseData);
        } else {
            if (initElkStackLoggingForSession()) elkStackLog.logger.error(elkStackLog.modelFactory.resModel('wrapInSuccessCheck', data));else logger.error({ res: data });
            return Promise.reject(responseData);
        }
    });
};

ServiceClientBase.prototype.postApiRequest = function (url, queryString, postParams) {
    var headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    };

    var msg = {
        method: 'POST',
        url: url,
        queryString: queryString,
        body: postParams,
        headers: headers
    };

    return this.wrapInSuccessCheck(request.post(url).use(legacyIESupportWrapper).query(queryString).timeout(60000).set(headers).send(postParams));
};

ServiceClientBase.prototype.getApiRequest = function (url, queryString, headers) {
    getLogger();

    var defaults = {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    };

    if (headers) {
        for (var prop in headers) {
            defaults[prop] = headers[prop];
        }
    }

    //safari is caching OPTIONS requests and replaying them as GET requests.
    //passing in cache-control fixs this.
    try {

        if (typeof navigator !== 'undefined' && navigator && navigator.vendor && navigator.vendor.indexOf('Apple') > -1) {
            if (!defaults['cache-control']) {
                defaults['cache-control'] = 'no-cache';
                defaults['Access-Control-Expose-Headers'] = 'Cache-Control';
            }
        }
    } catch (e) {
        if (initElkStackLoggingForSession()) elkStackLog.logger.error(elkStackLog.modelFactory.methodModel('getApiRequest', e));else logger.error("Error trying to set 'cache-control' for safari OPTIONS bug", e);
    }

    if (queryString) {
        if (queryString.token) {
            delete queryString.token;
        }
        if (queryString.deviceId) {
            delete queryString.deviceId;
        }
    }

    var msg = {
        method: 'GET',
        url: url,
        headers: defaults,
        queryString: queryString
    };

    return this.wrapInSuccessCheck(request.get(url).use(legacyIESupportWrapper).query(queryString).timeout(60000).set(defaults).send());
};

/**
 * Grabs the config urls for a quick easy way to load them up after someone has
 * setup the environment.
 * @returns {object} urls object from the set environments configuration file
 */
ServiceClientBase.prototype.getUrl = function () {
    return require('../lib/config').urls;
};

/**
 * pulls items from params to send to api as query string values
 * @param params
 * @returns {{lang: string, cntry: string, sourceCode: string, version: string}}
 */
ServiceClientBase.prototype.pullQueryStringParams = function (params) {
    return {
        lang: params.lang,
        cntry: params.cntry,
        sourceCode: params.sourceCode,
        version: params.version
    };
};

/*
 This is only needed right now because of this bug. Can get rid of if this gets merged in.  
 https://github.com/trevorreeves/superagent-legacyIESupport/issues/3

 The code is pulled from a patch submitted, but not yet merged. 
 https://github.com/trevorreeves/superagent-legacyIESupport/pull/4
 */
var legacyIESupportWrapper = function legacyIESupportWrapper(superagent) {
    if (typeof XDomainRequest !== "undefined" // IE 8, 9, & 10
    && !('withCredentials' in new XMLHttpRequest())) {
        //ONLY IE10
        //use the legacy support page
        legacyIESupport(superagent);
    }
};

module.exports = ServiceClientBase;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/serviceClientBase.js
// module id = 14
// module chunks = 0